import { User } from "lucide-react";
import { Reveal, Overline, IMG } from "./shared";

export const About = () => (
  <section id="a-propos" className="bg-white py-24 lg:py-36" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="order-2 lg:order-1 lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="overflow-hidden">
                <img
                  src={IMG.hero}
                  alt="Bel immeuble résidentiel entretenu au pied des montagnes valaisannes"
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover"
                />
              </div>
              <div className="relative z-10 -mt-16 ml-auto mr-4 aspect-[3/4] w-40 overflow-hidden border-4 border-white shadow-xl sm:w-52 lg:-mt-24">
                <img
                  src="/assets/gallery/steve-rosset-portrait.webp"
                  alt="Steve Rosset, fondateur de Rosset Conciergerie & Services, lors d'une intervention sur une toiture vitrée en Valais"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
              <p className="mt-4 text-right text-[11px] uppercase tracking-[0.2em] text-nuit/35">Sion — Valais central</p>
            </div>
          </Reveal>
        </div>

        <div className="order-1 lg:order-2 lg:col-span-7">
          <Reveal>
            <Overline>À propos</Overline>
            <h2 className="font-display mt-4 text-3xl font-medium leading-tight tracking-tight text-nuit sm:text-4xl lg:text-5xl">
              Un service de proximité, avec un interlocuteur qui connaît votre bien
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-nuit/70">
              <p>
                Je suis <strong className="font-semibold text-nuit">Steve Rosset</strong>, fondateur de
                Rosset Conciergerie &amp; Services. Mon parcours professionnel m'a permis d'acquérir une
                expérience polyvalente dans la construction, la rénovation, l'entretien et le paysagisme.
              </p>
              <p>
                Au fil des années, j'ai appris qu'un bâtiment bien entretenu ne dépend pas uniquement de
                sa propreté. Il faut également savoir observer, anticiper les petits problèmes et intervenir
                lorsque cela est nécessaire.
              </p>
              <p>
                C'est cette approche que je souhaite apporter : un service sérieux, humain et polyvalent,
                avec un interlocuteur facilement joignable et réellement impliqué dans l'entretien des biens
                qui lui sont confiés. Mon expérience de la construction, de la rénovation et du paysagisme
                est aujourd'hui entièrement au service de la conciergerie, de l'entretien et du nettoyage
                de votre bien.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-2">
              {["Conciergerie", "Entretien", "Nettoyage", "Petits travaux", "Extérieurs", "Débarras"].map((d) => (
                <span key={d} className="border border-nuit/15 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-petrole">
                  {d}
                </span>
              ))}
            </div>
            <p className="font-display mt-10 border-l-2 border-lagoon pl-6 text-xl font-medium leading-snug text-nuit">
              Trouver une solution pratique et fournir un travail soigné.
            </p>
            <div className="mt-8 bg-nuit p-6 lg:p-8">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lagoon">Ce que cela change pour vous</p>
              <p className="mt-3 text-sm leading-relaxed text-white/75 sm:text-base">
                Vous ne faites pas appel uniquement à une personne qui nettoie, mais à un interlocuteur
                polyvalent qui apprend à connaître votre immeuble, repère ce qui doit être surveillé
                et peut réaliser lui-même de nombreux petits et moyens travaux.
              </p>
              <p className="mt-4 border-t border-white/10 pt-4 text-sm leading-relaxed text-white/55">
                Et pour les interventions qui demandent du renfort, je collabore régulièrement avec
                l'entreprise Fontana Chris Services de Monthey.
              </p>
            </div>
            <p className="mt-6 text-xs uppercase tracking-[0.2em] text-nuit/40">
              Rosset Conciergerie &amp; Services — une entreprise de Rosset Solutions
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
